export default {
    name: 'header',
    component() {
        return {
            open: false,
            body: "",
            scrollTop: 0,
            visible: false,
            sticky: false,
            offset: 90,
            lastScrollTop: 0,
            startColorPage: document.querySelector('[data-start-color-page]')?.dataset.startColorPage || 'white',
            // searchVal: "",
            // openSubheader: '',
            // activeSubCollection: {
            //     title: "",
            //     handle: "",
            //     url: ""
            // },
            openSubmenu: '',
            maxHeightSubmenu: 0,
            openSearch: false,
            maxHeightSearchmenu: 0,

            init() {
                this.body = document.querySelector("body");

                document.querySelector('main').classList.add(`start--${this.startColorPage}`);
                document.querySelector('.header').classList.add(`start--${this.startColorPage}`);
                // document.querySelector('[data-search]').classList.add(`start--${this.startColorPage}`);
                document.querySelector('.nav__submenu').classList.add(`start--${this.startColorPage}`);
                document.querySelector('.nav__submenu__mobile').classList.add(`start--${this.startColorPage}`);


                if(document.querySelector('[data-padding-bottom]')?.dataset.paddingBottom == 'true') {
                    document.querySelector('main').classList.add('pb-xxl');
                }

                if(document.querySelector('[data-padding-top]')?.dataset.paddingTop == 'true') {
                    this.startColorPage == 'black' ? document.querySelector('main').classList.add('md:pt-lg') : document.querySelector('main').classList.add('md:pt-xxl');
                    document.querySelector('main').classList.add('max-md:pt-lg');
                }

                setTimeout(() => {
                    if(document.querySelector('.shopify-policy__container')) {
                        document.querySelector('.shopify-policy__container').setAttribute('data-header-color', 'white');
                    }
                }, 100);

                setTimeout(() => {
                    let headerHeight = document.querySelector('.header__content-primary').getBoundingClientRect().height;
                    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

                    window.addEventListener("resize", () => {
                        let headerHeight = document.querySelector('.header__content-primary').getBoundingClientRect().height;
                        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
                    });
                }, 100);

                this.stickyNav();
                window.addEventListener("scroll", () => {
                    this.stickyNav();
                });

                this.$watch("openSubmenu", (val) => {
                    let headerHeight = document.querySelector('.header__content-primary').getBoundingClientRect().height;

                    if(val != '') {
                        if(this.openSearch) {
                            this.openSearch = false;
                        }
                        
                        let navItem = document.querySelector(`[data-submenu="${val}"]`);
                        
                        if(window.innerWidth < 1000) {
                            navItem = document.querySelector(`[data-submenu-mobile]`);
                        }
                        
                        let navItemHeight = navItem.getBoundingClientRect().height;
                        document.querySelector('.header--background').style.maxHeight = `${navItemHeight + headerHeight}px`;
                        document.querySelector('.header--background').style.height = `${navItemHeight + headerHeight}px`;

                        // this.enableBodyScrollLock();

                    } else {
                        if(!this.openSearch) {
                            document.querySelector('.header--background').style.maxHeight = `${headerHeight}px`;
                            // this.disableBodyScrollLock();
                        }
                    }
                });

                this.$watch("openSearch", (val) => {
                    let headerHeight = document.querySelector('.header__content-primary').getBoundingClientRect().height;
                    let searchItem = document.querySelector('.nav__searchmenu');
                    let searchItemHeight = searchItem.getBoundingClientRect().height;

                    if(val != '') {
                        if(this.openSubmenu != '') {
                            this.openSubmenu = '';
                        }
                        document.querySelector('.header--background').style.maxHeight = `${searchItemHeight + headerHeight}px`;
                        document.querySelector('.header--background').style.height = `${searchItemHeight + headerHeight}px`;
                        // this.enableBodyScrollLock();
                    } else {
                        if(this.openSubmenu == '') {
                            document.querySelector('.header--background').style.maxHeight = `${headerHeight}px`;
                            // this.disableBodyScrollLock();
                        }
                    }
                });


                const headerElement = document.querySelector(".header");

                const isIntersecting = (rect1, rect2) => {
                    return !(
                        rect1.bottom < rect2.top ||
                        rect1.top > rect2.bottom ||
                        rect1.right < rect2.left ||
                        rect1.left > rect2.right
                    );
                };

                window.addEventListener("scroll", () => {
                    const headerRect = headerElement.getBoundingClientRect();
                    const blocks = document.querySelectorAll("[data-header-color]");
                    
                    let intersectingBlock = null;
                    
                    for (const block of blocks) {
                        const blockRect = block.getBoundingClientRect();
                        if (isIntersecting(headerRect, blockRect)) {
                            intersectingBlock = block;
                            break;
                        }
                    }

                    if (!intersectingBlock) return;

                    const color = intersectingBlock.dataset.headerColor;

                    this.setHeaderColor(color);
                });

                // this.$watch("openSubheader", (val) => {
                //     console.log(val);
                // });
            },

            toggleMobileMenu() {
                if(this.openSubmenu == 'mobile') {
                    this.openSubmenu = '';
                    this.disableBodyScrollLock();
                } else {
                    this.openSubmenu = 'mobile';
                    this.enableBodyScrollLock();
                }
            },

            setHeaderColor(color) {
                const headerElement = document.querySelector(".header");
                // const searchHeader = document.querySelector('[data-search]');
                const submenu = document.querySelector('.nav__submenu');
                const submenuMobile = document.querySelector('.nav__submenu__mobile');

                if(color == 'black' || color == 'dark_gray') {
                    headerElement.classList.add('start--black');
                    // searchHeader.classList.add('start--black');
                    submenu.classList.add('start--black');
                    submenuMobile.classList.add('start--black');

                    headerElement.classList.remove('start--white');
                    // searchHeader.classList.remove('start--white');
                    submenu.classList.remove('start--white');
                    submenuMobile.classList.remove('start--white');

                    headerElement.classList.remove('start--secondary');
                    // searchHeader.classList.remove('start--secondary');
                    submenu.classList.remove('start--secondary');
                    submenuMobile.classList.remove('start--secondary');

                } else if(color == 'white' || color == 'gray') {
                    headerElement.classList.add('start--white');
                    // searchHeader.classList.add('start--white');
                    submenu.classList.add('start--white');
                    submenuMobile.classList.add('start--white');
                    
                    headerElement.classList.remove('start--black');
                    // searchHeader.classList.remove('start--black');
                    submenu.classList.remove('start--black');
                    submenuMobile.classList.remove('start--black');
                    
                    headerElement.classList.remove('start--secondary');
                    // searchHeader.classList.remove('start--secondary');
                    submenu.classList.remove('start--secondary');
                    submenuMobile.classList.remove('start--secondary');
                    
                } else if(color == 'secondary') {
                    headerElement.classList.add('start--secondary');
                    // searchHeader.classList.add('start--secondary');
                    submenu.classList.add('start--secondary');
                    submenuMobile.classList.add('start--secondary');
                    
                    headerElement.classList.remove('start--black');
                    // searchHeader.classList.remove('start--black');
                    submenu.classList.remove('start--black');
                    submenuMobile.classList.remove('start--black');
                    
                    headerElement.classList.remove('start--white');
                    // searchHeader.classList.remove('start--white');
                    submenu.classList.remove('start--white');
                    submenuMobile.classList.remove('start--white');
                }
            },

            stickyNav() {
                const top =
                    window.scrollY ||
                    window.scrollTop ||
                    document.getElementsByTagName("html")[0].scrollTop;
                let st = window.pageYOffset || document.documentElement.scrollTop;
        
                if (top > this.offset) {
                    this.sticky = true;
                    if (st > this.lastScrollTop) {
                        this.visible = false;
                        this.openSubmenu = '';
                        this.openSearch = false;
                        this.lastScrollTop = st <= 0 ? 0 : st;
                    } else {
                        if (st + 100 < this.lastScrollTop) {
                            this.visible = true;
                            this.lastScrollTop = st <= 0 ? 0 : st;
                        }
                    }
                } else {
                    this.sticky = false;
                    this.visible = false;
                    this.lastScrollTop = st <= 0 ? 0 : st;
                }
            },

            enableBodyScrollLock() {
                this.scrollTopLock =
                    document.documentElement.scrollTop || document.body.scrollTop;
                this.body.style.overflow = "hidden";
                this.body.style.position = "fixed";
                this.body.style.top = `-${this.scrollTopLock}px`;
                this.body.style.width = "100%";
            },
        
            disableBodyScrollLock() {
                this.body.style.removeProperty("overflow");
                this.body.style.removeProperty("position");
                this.body.style.removeProperty("top");
                this.body.style.removeProperty("width");
                window.scrollTo(0, this.scrollTopLock);
            },
        }
    }
}